import { Button } from "./Button"

export class StateButton extends Button {
    protected _states: any;
    protected _texturesState: string;

    constructor(states: any, initialState: string) {
        super(states[initialState]);
        this._texturesState = initialState;
        this._states = states;
    }

    state(state?: string): any {
        if(state == undefined)
            return this._texturesState;
        this._texturesState = state;
        this.textures = this._states[state];

        this.setImageForState(Button.STATE_UP);
    }
}
